import { parseAsBoolean, useQueryState } from 'nuqs'

export function useInviteUsersModal() {
  const [isShowing, setIsShowing] = useQueryState(
    'isShowingInviteUsersModal',
    parseAsBoolean.withDefault(false),
  )

  return {
    isShowing,
    show: () => setIsShowing(true),
    hide: () => setIsShowing(false),
  }
}
